import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Navbar, Page } from "../components";
import * as ROUTES from "../constant/routes";
import { getOrderHistory, getSetOrderHistory } from "../assets/Js/script";
import FastAverageColor from "fast-average-color";
import img from "../assets/images/login/login1.jpg";
import { data } from "autoprefixer";
import moment from "moment";
import OrderHistoryHeader from "../components/OrderHistoryHeader";

export default function OrderDetails({ OrderDetails, setOrderDetails }) {
  const navigate = useNavigate();

  const [orders, setOrders] = useState(null);
  const [date, setDate] = useState(null);
  const { order_id } = useParams();
  const { order_details } = useParams();
  const [canSelect, setCanSelect] = useState(false);
  const [selected, setSelected] = useState([]);
  const [book, setBook] = useState(null);
  const [isSet, setIsSet] = useState(false)

  function handleSelection(book) {
    setSelected((prevState) => {
      if (prevState.includes(book.id)) {
        return prevState.filter((item) => item !== book.id);
      } else {
        return [...prevState, book.id];
      }
    });
  }
  const getSetOrderHis = async () => {
    setIsSet(true)
    const { response, error } = await getSetOrderHistory(
      "organisationId",
      order_id.split("=")[1]
    );
    if (response.status === "success") {
      setOrders({ ...response.data });
    }
    setDate(
      response.data.orderIdGroup[order_details.split("=")[1]][0].createdAt
    );

  }
  useEffect(() => {

    (async () => {
      const { response, error } = await getOrderHistory(
        "organisationId",
        order_id.split("=")[1]
      );

      const id = order_details.split("=")[1];
      if (response.status === "success" && response.data.orderIdGroup[order_details.split("=")[1]]) {
        setOrders({ ...response.data });
        setDate(
          response.data.orderIdGroup[order_details.split("=")[1]][0].createdAt
        );
      } else {
        getSetOrderHis()
      }


      // setIsLoading(false);
    })();
  }, []);

  // console.log(orders, "hello");
  // console.log(date, "hello..hlk");

  function filterData() {
    const test = [];
    const id = order_details.split("=")[1];

    if (orders) {
      for (var i = 0; i < orders?.bookData?.length; i++) {
        for (var x = 0; x < orders?.orderIdGroup[id].length; x++) {
          if (
            orders?.bookData[i]?.parentId ===
            orders?.orderIdGroup[id][x]?.bookId
          ) {
            test.push(orders?.bookData[i]);
          } else console.log("not working!");
        }
      }
    }
    if (test.length > 0) {
      setBook([...test]);
    }
    return test;
  }
  function filterDataForSet() {
    const test = [];
    const id = order_details.split("=")[1];

    if (orders) {
      for (var i = 0; i < orders?.setData?.length; i++) {
        for (var x = 0; x < orders?.orderIdGroup[id].length; x++) {
          if (
            orders?.setData[i]?.id ===
            orders?.orderIdGroup[id][x]?.setId
          ) {
            test.push(orders?.setData[i]);
          } else console.log("not working!");
        }
      }
    }
    if (test.length > 0) {
      setBook([...test]);
    }
    return test;
  }

  const [color, setColor] = useState();

  const fac = new FastAverageColor();
  function colorimg() {
    if (book) {
      fac.getColorAsync(img).then((color) => setColor(color.hex));
    }
  }

  function calculateExpiry(data) {
    const date1 = Date.parse(data.expiresOn);

    const date2 = Date.parse(data.createdAt);

    const difference = date1 - date2;

    const day = Math.round(difference / (3600000 * 24));

    const percent = day / (data.validity * 365);

    return { day, percent: percent * 100 };
  }

  function getLeftaccessId(id) {
    for (
      let i = 0;
      i < orders?.orderIdGroup[order_details.split("=")[1]].length;
      i++
    ) {
      if (orders?.orderIdGroup[order_details.split("=")[1]][i].bookId === id) {
        return orders?.orderIdGroup[order_details.split("=")[1]][i];
      }
    }
  }


  useEffect(() => {
    colorimg();
  }, [book, color]);

  useEffect(() => {
    if (isSet) {
      filterDataForSet()
    } else {
      filterData();

    }

  }, [orders]);

  return (
    <Page>
      <Navbar />
      <OrderHistoryHeader />
      <div
        className={`mb-2 mt-8 px-4 block lg:hidden flex lg:hidden justify-between items-center w-screen `}
      >
        <h1 className=" flex items-center text-mobile-h1  lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
          <span onClick={() => navigate(-1)} className=" mr-3">
            <svg
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                fill="#702963"
              />
            </svg>
          </span>
          Order Details
        </h1>
        <div className="flex lg:hidden items-center">
          <button className="mr-5">
            <svg
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                stroke="#702963"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button>
            <svg
              width="28"
              height="24"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                fill="#702963"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="w-full lg:p-4 lg:px-6 lg:border-1 border-solid border-primary-dark-20">
        <h2 className="hidden text-h4 lg:flex items-center font-semibold text-heading">
          <button className="mr-3" onClick={() => navigate(-1)}>
            <svg
              width="9"
              height="16"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.05363 15.7514C6.87311 15.752 6.69475 15.7149 6.53165 15.6429C6.36855 15.5708 6.22486 15.4657 6.11113 15.3352L0.274881 8.58516C0.0971576 8.38386 0 8.13136 0 7.87078C0 7.61021 0.0971576 7.35771 0.274881 7.15641L6.31655 0.406409C6.52165 0.176665 6.81638 0.0321876 7.13589 0.00476044C7.45541 -0.0226668 7.77354 0.0692029 8.0203 0.260159C8.26706 0.451115 8.42224 0.725515 8.4517 1.02299C8.48116 1.32047 8.38248 1.61666 8.17738 1.84641L2.77613 7.87641L7.99613 13.9064C8.14389 14.0715 8.23775 14.2726 8.2666 14.4859C8.29546 14.6991 8.2581 14.9156 8.15895 15.1097C8.0598 15.3038 7.90301 15.4674 7.70712 15.5811C7.51124 15.6948 7.28446 15.7539 7.05363 15.7514Z"
                fill="#494949"
              />
            </svg>
          </button>
          Order history
        </h2>
        <div className="lg:my-6 py-2 px-5 lg:border-1 border-solid border-[rgba(174,174,174,0.36)]">
          <div className="mb-9 lg:mb-12 mt-4 flex justify-between items-center">
            <div className="flex flex-col items-start">
              <p className=" text-secondary-dark text-[20px] lg:text-h4 text-montserrat font-semibold">
                Order Id:{" "}
                <span className="uppercase">{order_details.split("=")[1]}</span>
              </p>
              <p className="text-[18px] lg:text-h5 text-secondary-light">
                {moment(date).format("DD MMMM, YYYY")}
              </p>
            </div>
            {/* <div className="hidden lg:block">
              {canSelect ? (
                <>
                  <button
                    onClick={() => setCanSelect(false)}
                    className="outline-0 border-0 font-semibold text-h5 text-secondary-dark mr-10"
                  >
                    Cancel
                  </button>
                  <button className="border-1 border-solid border-[rgba(174,174,174,0.39)] text-heading py-3 px-[38px] bg-[#fbfafb] font-bold">
                    Renew selected
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setCanSelect(true)}
                  className="border-1 border-solid border-[rgba(174,174,174,0.39)] text-heading py-3 px-[38px] bg-[#fbfafb] font-bold"
                >
                  Select
                </button>
              )}
            </div> */}
            <div className="block lg:hidden">
              {!canSelect && (
                <button
                  onClick={() => setCanSelect(true)}
                  className="text-p1 px-3 py-[8px] bg-primary-dark leading-[19px] w-[92px] text-primary-white font-semibold"
                >
                  Select
                </button>
              )}
            </div>
          </div>
          {/* {canSelect && (
            <div className="flex lg:hidden mb-[40px] items-center justify-between">
              <button
                onClick={() => setCanSelect(false)}
                className="text-p1 leading-[19px] text-secondary-dark font-semibold"
              >
                Cancel
              </button>
              <div className="flex items-center">
                <button className="text-p1 leading-[19px] text-tertiary-dark font-semibold mr-[27px]">
                  Select all
                </button>
                <button className="text-p1 px-3 py-[8px] bg-primary-dark leading-[19px] text-primary-white font-semibold">
                  Renew selected
                </button>
              </div>
            </div>
          )} */}

          {book?.map((item, index) =>
            canSelect ? (
              <div key={item.id} className="relative flex">
                <div className="absolute top-6 right-2 lg:relative lg:h-[206px] w-6 mr-3 flex justify-center items-center">
                  {selected.includes(item.id) ? (
                    <div className=" bg-primary-dark flex justify-center items-center rounded-full w-6 h-6">
                      <svg
                        width="15"
                        height="10"
                        viewBox="0 0 15 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.313241 3.75601C0.51387 3.57208 0.785945 3.46875 1.06963 3.46875C1.35332 3.46875 1.6254 3.57208 1.82603 3.75601L5.60906 7.22533L13.173 0.287674C13.2723 0.196515 13.3903 0.124192 13.5201 0.0748331C13.6499 0.025474 13.789 4.5617e-05 13.9295 6.13195e-08C14.0701 -4.54943e-05 14.2092 0.0252926 14.3391 0.0745675C14.4689 0.123842 14.5869 0.196089 14.6863 0.287183C14.7857 0.378277 14.8646 0.486433 14.9184 0.605478C14.9722 0.724522 14.9999 0.852123 15 0.980994C15 1.10987 14.9724 1.23748 14.9187 1.35656C14.865 1.47564 14.7862 1.58385 14.6868 1.67501L5.60906 10L0.313241 5.14335C0.112673 4.95936 0 4.70984 0 4.44968C0 4.18952 0.112673 3.94 0.313241 3.75601Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  ) : (
                    <div className="w-6 h-6 bg-neutral-50 rounded-full"></div>
                  )}
                </div>
                <div
                  onClick={() => handleSelection(item)}
                  className=" flex justify-between items-center w-full h-[206px] border-1 border-solid border-primary-dark-20 bg-[#fbfafb] mb-6"
                >
                  {/* {colorimg(item?.imageCoverFront)} */}
                  <div className="flex gap-3">
                    <div style={{ background: item?.backgroundColor }} className="flex items-center justify-center bg-neutral-10 w-fit lg:w-[170px] h-[203px] lg:h-[206px] py-5 bg-[#ccc] px-2">
                      {(isSet ? item?.cover : item?.imageCoverFront) && (
                        <img
                          src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${isSet ? 'setCovers' : 'books'}/${isSet ? item?.cover : item?.imageCoverFront}`}
                          alt="Cover"
                          className="h-full object-cover w-[110px] h-[136px] "
                        />
                      )}
                    </div>
                    <div className="py-3 lg:w-fit w-[229px] lg:px-6 lg:py-4 flex flex-col lg:justify-between">
                      <p
                        className={`hidden lg:block text-secondary-light text-[14px] uppercase`}
                      >
                        {item?.id}
                      </p>
                      <p className=" leading-[22px] text-heading text-left font-semibold text-h5">
                        {item?.title}
                      </p>
                      <p className="text-p1 mb-[20px] text-secondary-dark font-semibold">
                        {item.Bauthors?.map(
                          (auther, index, arr) => <span>{
                            (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                          }</span>
                        )}                        </p>
                      <p className="hidden lg:block text-[rgba(112,41,99,0.65)] font-semibold text-montserrat">
                        {getLeftaccessId(item.parentId).totalCount} Access Ids
                      </p>
                      <div className="flex items-center mt-[30px] lg:mt-0">
                        <div className="w-[106px] mt-[22px] lg:mt-0 lg:w-32 h-2 bg-primary-light rounded-full">
                          <div
                            className="h-full bg-primary-dark rounded-full"
                            style={{
                              width:
                                calculateExpiry(getLeftaccessId(item.parentId))
                                  .percent + "%",
                            }}
                          ></div>
                        </div>
                        <p className="text-sm text-secondary-light ml-4">
                          {calculateExpiry(getLeftaccessId(item.parentId)).day}{" "}
                          days
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <button className="hidden lg:block border-1 mr-6 border-solid border-primary-dark-20 text-p1 font-semibold w-[183px] h-12">
                    Renew
                  </button> */}
                </div>
              </div>
            ) : (
              <div className=" flex justify-between items-center w-full h-[206px] border-1 border-solid border-primary-dark-20 bg-[#fbfafb] mb-6">
                <div className="flex gap-3">
                  {/* {colorimg(item?.imageCoverFront)} */}
                  <div style={{ background: item?.backgroundColor }} className="flex items-center justify-center bg-neutral-10 w-fit lg:w-[170px] h-[203px] lg:h-[206px] py-5 bg-[#ccc] px-2">
                    {(isSet ? item?.cover : item?.imageCoverFront) && (
                      <img
                        src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${isSet ? 'setCovers' : 'books'}/${isSet ? item?.cover : item?.imageCoverFront}`}
                        alt="Cover"
                        className="h-full object-cover w-[110px] h-[136px] "
                      />
                    )}
                  </div>
                  <div className="py-3 lg:w-fit w-[229px] lg:px-6 lg:py-4 flex flex-col lg:justify-between">
                    <p className=" text-secondary-light whitespace-nowrap overflow-hidden sm:w-full w-[100px] text-ellipsis text-[14px] uppercase">
                      {item.id}
                    </p>
                    <p className="leading-[22px] text-heading text-left font-semibold text-h5">
                      {item?.title}
                    </p>
                    <p className="text-p1 mb-[20px] text-secondary-dark font-semibold">
                      {item.Bauthors?.map(
                        (auther, index, arr) => <span>{
                          (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                        }</span>
                      )}                      </p>
                    <p className="hidden lg:block text-[rgba(112,41,99,0.65)] font-semibold text-montserrat">
                      {getLeftaccessId(item.parentId).totalCount} Access Ids
                    </p>
                    <div className="flex items-center">
                      <div className="w-[106px] mt-[22px] lg:mt-0 lg:w-32 h-2 bg-primary-light rounded-full">
                        <div
                          className="h-full bg-primary-dark rounded-full"
                          style={{
                            width:
                              calculateExpiry(getLeftaccessId(item.parentId))
                                .percent + "%",
                          }}
                        ></div>
                      </div>
                      <p className="text-sm text-secondary-light ml-8">
                        {calculateExpiry(getLeftaccessId(item.parentId)).day}{" "}
                        days
                      </p>
                    </div>
                    {/* <button className="w-[88px] h-[30px] mt-4 lg:hidden bg-primary-dark text-primary-white font-semibold">
                      Renew
                    </button> */}
                  </div>
                </div>
                {/* <button className="hidden lg:block border-1 mr-6 border-solid border-primary-dark-20 text-p1 font-semibold w-[183px] h-12">
                  Renew
                </button> */}
              </div>
            )
          )}
        </div>
      </div>
    </Page>
  );
}
